import { Box } from '@mui/material';
import { WccDto } from '@sr/dto';
import { WccList } from 'entities/wcc/wcc-list';
import { useDeleteWcc, useWccList } from 'entities/wcc/wcc-list/lib';
import { deleteInvoiceWcc } from 'features/invoice/invoice-wcc/api';
import { useInvoiceWcc } from 'features/invoice/invoice-wcc/lib';
import { WccFilter } from 'features/wcc/wcc-filter';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { useSearchParams } from 'react-router-dom';
import { usePagingParams } from 'shared/hooks/paging-params';
import { NotificationsConfig, useSnack } from 'shared/ui/snack';
import { ListTotalsCard } from 'shared/ui/totals-card';

const notificationsConfig: NotificationsConfig = {
  itemTitleForm1: 'акт выполненных работ',
  itemTitleForm2: 'акта выполненных работ',
  gender: 'neutral'
};
type Props = {
  type?: 'client' | 'supplier'
}
export const WccListTab = ({ type='client' }: Props) => {
  const { showSuccessDelete, showFailedDelete } = useSnack(notificationsConfig);
  const showConfirmDialog = useConfirmDialog();

  const [searchParams] = useSearchParams();
  const mergedParams = new URLSearchParams(searchParams);

  const [paging, setPaging] = usePagingParams();
  const collection = useWccList(paging, mergedParams.toString(), type);

  const { deleteByInvoiceId: deleteInvoiceWcc } = useDeleteWcc();


  const handleDeleteWcc = (wcc: WccDto) => {
    showConfirmDialog({
      content: 'Удалить акт выполненных работ?'
    })
      .then(() => {
        deleteInvoiceWcc(wcc.invoice.id)
          .then(showSuccessDelete)
          .catch(e => showFailedDelete(e))
          .finally(() => setPaging({ ...paging }));
      });
  };

  return (
    <Box mt={2}>
      <WccFilter />
      <WccList
        collection={collection}
        paging={paging}
        onChangePaging={setPaging}
        type={type}
        onDelete={handleDeleteWcc} />
    </Box>
  );
};
